import { render, staticRenderFns } from "./ServiceRequestExpansionButton.vue?vue&type=template&id=186afdaf&scoped=true"
import script from "./ServiceRequestExpansionButton.vue?vue&type=script&lang=js"
export * from "./ServiceRequestExpansionButton.vue?vue&type=script&lang=js"
import style0 from "./ServiceRequestExpansionButton.vue?vue&type=style&index=0&id=186afdaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186afdaf",
  null
  
)

export default component.exports